import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions, ChartData } from "chart.js";
import { CustomCard, TitleComponent } from "ui-components";
ChartJS.register(ArcElement, Tooltip, Legend);

type PieChartProps = {
  data: ChartData <'pie', number []>;
  options: ChartOptions<'pie'>;
  title: string;
};

function PieChart({
  data,
  options,
  title
}: PieChartProps) {
  

  return (
    <CustomCard marginTop="10px">
      <TitleComponent  marginTop={"5px"}>{title}</TitleComponent>
      <Pie data={data} options={options} />
    </CustomCard>
  );
}

export default PieChart;